var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 356,
    viewBox: "0 0 277 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_1480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.414 0H65.487C29.716 0 0 31.595 0 67.365V216.293C0 251.994 29.716 281.57 65.486 281.57H97.637L114.27 310.59L139.949 355.547L165.629 310.799L182.262 281.57H214.413C250.113 281.57 276.142 251.994 276.142 216.293V67.365C276.142 31.595 250.114 0 214.414 0Z",
    fill: "#131312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.239 209C105.772 209 103.039 208.067 101.039 206.2C99.1723 204.2 98.239 201.533 98.239 198.2C98.239 194.733 99.1723 192.133 101.039 190.4C103.039 188.667 105.772 187.8 109.239 187.8H131.639V89.5999H144.039L114.639 107.4C112.106 108.867 109.706 109.467 107.439 109.2C105.306 108.8 103.439 107.867 101.839 106.4C100.372 104.8 99.3723 102.933 98.839 100.8C98.3057 98.6666 98.439 96.5332 99.239 94.3999C100.172 92.1332 101.906 90.2666 104.439 88.7999L132.039 72.1999C134.706 70.5999 137.372 69.2666 140.039 68.1999C142.706 66.9999 145.172 66.3999 147.439 66.3999C150.239 66.3999 152.572 67.1999 154.439 68.7999C156.306 70.2666 157.239 72.7332 157.239 76.1999V187.8H177.639C181.106 187.8 183.772 188.667 185.639 190.4C187.639 192.133 188.639 194.733 188.639 198.2C188.639 201.667 187.639 204.333 185.639 206.2C183.772 208.067 181.106 209 177.639 209H109.239Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_1480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276.196,
    height: 355.547,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop1);
export default __webpack_public_path__ + "static/media/stop1.5d328e811d9aabb6f1148ee27e8b29cd.svg";
export { ForwardRef as ReactComponent };